import { createContext, useContext } from 'react';

/**
 * Injected platform mechanics `PhotoField` needs but the framework-agnostic
 * core (`useFormRenderer.ts`) has no business knowing about — direct-to-blob
 * upload is a web (and eventually React Native) concern, not a forms-engine
 * one. No caller exists yet (M1-19/M1-20 build real submission storage);
 * `PhotoField` falls back to a local-only preview when `uploadPhoto` is
 * absent, so the field still works end to end before that caller exists.
 */
export interface FormRendererContextValue {
  uploadPhoto?: (file: File) => Promise<string>;
}

const FormRendererContext = createContext<FormRendererContextValue>({});

export function useFormRendererContext(): FormRendererContextValue {
  return useContext(FormRendererContext);
}

export const FormRendererProvider = FormRendererContext.Provider;
